/* LicensesTableComponent.js */

"use strict";

const DataTableComponent = require("./DataTableComponent");
const { dateFormatter, numberFormatter } = require("./cellFormatters");

const BASE_SOLUTION = "GLUWARE";

class LicensesTableComponent extends DataTableComponent {
    setOrgId(orgId) {
        this._orgId = orgId;
        return this;
    }
    getOrgId() {
        return this._orgId;
    }
    _getColumns() {
        const actions = Object.keys(this.actions);
        let width = actions.length ? 224 : 237;
        const generalColumns = [
            {
                id: "contractId",
                name: "Contract ID",
                field: "contractId",
                toolTip: "Display name assigned by Gluware for the license",
                width: width
            },
            {
                id: "solutionKey",
                name: "Solution Key",
                field: "solutionKey",
                toolTip: "The Gluware Solution licensed",
                cssClass: "centered",
                headerCssClass: "centered",
                width: width
            },
            {
                id: "activeDate",
                name: "Activation Date",
                field: "activeDate",
                toolTip: "Date license started",
                formatter: dateFormatter,
                cssClass: "centered",
                headerCssClass: "centered",
                width: width
            },
            {
                id: "expireDate",
                name: "Expiration Date",
                field: "expireDate",
                toolTip: "Date license expires at 11:59:59 PM UTC",
                formatter: dateFormatter,
                cssClass: "centered",
                headerCssClass: "centered",
                width: width
            },
            {
                id: "deviceCount",
                name: "License Limit",
                field: "deviceCount",
                toolTip:
                    "Number of licenses purchased for this organization and any child organizations\n",
                formatter: numberFormatter,
                cssClass: "centered",
                headerCssClass: "centered",
                width: width
            }
        ];
        const actionsColumn = [
            {
                id: "action",
                minWidth: 65,
                maxWidth: 65,
                name: "Action",
                field: "licenseKey",
                toolTip: "Delete a license",
                formatter: deleteActionForLicense(this),
                cssClass: "centered",
                headerCssClass: "centered"
            }
        ];

        return actions.length ? generalColumns.concat(actionsColumn) : generalColumns;
    }

    _parseData(data) {
        return Array.isArray(data)
            ? data.sort((a, b) => {
                  if (a.licenseKey !== b.licenseKey) {
                      return 0;
                  }
                  if (a.solutionKey === "GLUWARE") {
                      return -1;
                  }
                  if (b.solutionKey === "GLUWARE") {
                      return 1;
                  }
                  return a.solutionKey.localeCompare(b.solutionKey);
              })
            : data;
    }

    getItemMetadata(metaData, row, item) {
        const orgId = this.getOrgId();
        const isInherited = item.tenantId !== orgId;

        metaData = Object.assign({}, metaData, { isInherited });

        if (isInherited) {
            Object.assign(metaData, {
                cssClasses: (metaData.cssClasses || "") + " " + "inherited"
            });
        }
        return metaData;
    }
}

function deleteActionForLicense(model) {
    return (row, cell, licenseKey /*, columnDef, dataContext*/) => {
        const dataView = model.renderer.dataView;

        if (deleteButtonIsVisible(dataView, row)) {
            const button = document.createElement("base-icon-gl");
            button.dataset.icon = "common.trash_bin";
            button.setDarkTheme(true);

            button.setAttribute("role", "button");

            button.dataset.actionData = licenseKey;
            button.dataset.action = "delete";

            return button.outerHTML;
        } else {
            return "";
        }

        function deleteButtonIsVisible(dataView, row) {
            const isNotInherited = (dataView) => {
                const { isInherited } = dataView.getItemMetadata(row) || {};
                return !isInherited;
            };
            const nextLicenseFirstItem = (dataView, row) => {
                const prevPosItem = dataView.getItem(row - 1) || {};
                const item = dataView.getItem(row) || {};
                return prevPosItem.licenseKey !== item.licenseKey;
            };
            const baseSolutionCanBeDeleted = (dataView, row) => {
                const item = dataView.getItem(row);
                if (item.solutionKey !== BASE_SOLUTION || !item.active) {
                    return true;
                }
                const activeLicenses = dataView.getItems().filter((license) => license.active);

                const keysDistinctList = activeLicenses
                    .map((license) => license.licenseKey)
                    .filter((key, idx, list) => idx === list.indexOf(key));

                const activeBaseSolutionsAmount = activeLicenses.filter(
                    (license) => license.solutionKey === BASE_SOLUTION
                ).length;

                return activeBaseSolutionsAmount > 1 || keysDistinctList.length === 1;
            };

            return [isNotInherited, nextLicenseFirstItem, baseSolutionCanBeDeleted].every(
                (condition) => Boolean(condition(dataView, row))
            );
        }
    };
}

module.exports = LicensesTableComponent;
